
import { computed, defineComponent } from 'vue'
import useTheme from '@/composables/useTheme'

import HomeIcon from '../../assets/icons/home.svg?inline'
import AnalyticsIcon from '../../assets/icons/analytics.svg?inline'
import BriefcaseIcon from '../../assets/icons/briefcase.svg?inline'
import CogIcon from '../../assets/icons/cog.svg?inline'
import FolderIcon from '../../assets/icons/folder.svg?inline'
import EllipsisIcon from '../../assets/icons/ellipsis-h.svg?inline'
import SearchIcon from '../../assets/icons/search.svg?inline'
import SignOutIcon from '../../assets/icons/sign-out.svg?inline'

export default defineComponent({
  name: 'NavSidebarOne',
  components: {
    HomeIcon,
    AnalyticsIcon,
    BriefcaseIcon,
    CogIcon,
    FolderIcon,
    EllipsisIcon,
    SearchIcon,
    SignOutIcon,
  },
  setup() {
    const { currentTheme, currentMode, isLight } = useTheme()

    const navClasses = computed(() => {
      return isLight.value
        ? 'shadow-2xl'
        : `border-2 border-opacity-70 ${currentTheme.value.borders.card}`
    })

    return {
      currentMode,
      currentTheme,
      navClasses,
    }
  },
})
